import React, {useMemo, useState} from "react";
import ReactTable from "react-table-v6"
import { IconButton, Tooltip } from '@material-ui/core';
import { AddCircle, ArrowForward } from '@mui/icons-material';
import { useHistory } from "react-router-dom";
import AddSpaceToZoneModal from "../../components/AddSpaceToZoneModal"
import 'react-table-v6/react-table.css'

const ROUTE_ZONE_ADD = "/zones/add";


const ZoneList = (props) => {
    let [openAddToZoneModal, setOpenAddToZoneModal] = useState(false)

    let history = useHistory();

    const zoneAddPath = useMemo(() => {
        const params = new URLSearchParams()
        if (props.siteId) {
          params.set('site_id', props.siteId)
        }
        if (props.buildingId) {
          params.set('building_id', props.buildingId)
        }
        const search = params.toString()
        return { pathname: ROUTE_ZONE_ADD, search };
      }, [props.siteId, props.buildingId])

    const addToZone = (zone) => {
        props.addToZoneCallback(zone).then(() => {
            setOpenAddToZoneModal(false)
        })
	}

    const columns = [
        {
            Header: 'Name',
            accessor: 'name',
            style: {paddingTop: 15}
        },
        {
            Header: 'Type',
            accessor: 'brick_zone_type',
            style: {paddingTop: 15},
            Cell: p => {
                let nameParts = p.value.split("_");
                let name = "";
                nameParts.forEach(p => {
                    let part = p.substring(0, 1).toUpperCase() + p.substring(1, p.length)
                    name += (name.length > 0 ? " " + part : part) 
                })

                return name;
            },
        },
        {
            Header: '',
            accessor: 'id',
            Cell: p => {
                let link = "/zones/" + p.value

                return <IconButton 
                            variant="contained" 
                            color="primary"
                            aria-label={"View zone detail" }
                            size={"small"}
                            onClick={() => {
                                        history.push(link)
                                }}>
                            <ArrowForward />
                        </IconButton>
            },
            width: 50
        },
    ]
         
        return (
            <div className="space-list">
                <AddSpaceToZoneModal site_id={props.site_id} addToZoneCallback={addToZone} allZones={props.allZones} open={openAddToZoneModal} closeCallback={() => setOpenAddToZoneModal(false)} />
                <div className="space-add-mode">
                    {
                    props.addToZoneCallback ?
                    <Tooltip title="Add Zone to Space">
                        <IconButton
                        variant="contained"
                        color="primary"
                        aria-label={'Add zone'}
                        onClick={() => {
                            setOpenAddToZoneModal(true)
                        }}
                        >
                        <AddCircle style={{ fill: '#00b088', background: 'white' }} />
                        </IconButton>
                    </Tooltip>
                    : props.zones && props.zones.length > 0 ? (
                        <Tooltip title="Add a New Zone">
                            <IconButton
                            variant="contained"
                            color="primary"
                            aria-label={'Add zone'}
                            onClick={() => {
                                history.push(zoneAddPath);
                            }}
                            >
                            <AddCircle style={{ fill: '#00b088', background: 'white' }} />
                            </IconButton>
                        </Tooltip>
                    ) : null}
                </div>
                <div className="section-header">Zones </div>
                <div className="point-list-table">
                    { props.zones && props.zones.length > 0 ?
                        <ReactTable key={(props.zones && props.zones.length) || 0}
                            data={props.zones || []}
                            columns={columns}
                            minRows={0}
                            defaultPageSize={10}
                            showPagination={props.zones && props.zones.length > 10}
                        /> : 
                        (
                            <div className="bulk_add_prompt">
                              <IconButton
                                variant="contained"
                                color="primary"
                                aria-label={'Add new zone'}
                                onClick={() => {
                                  history.push(zoneAddPath);
                                }}
                              >
                                <AddCircle style={{ fill: '#00b088', background: 'white' }} />
                              </IconButton>
                              There are currently no zones configured. Add one now!
                            </div>
                        )
                    }
                </div>
            </div>



        )
}

export default ZoneList;
